const device_states = state => state.device_states
const device_state = state => state.device_state
const device_list_view = state => state.device_list_view
const device_revisions = state => state.device_revisions
const device_revisions_view = state => state.device_revisions_view
const profile_revisions = state => state.profile_revisions
const profile_revisions_view = state => state.profile_revisions_view
const operations = state => state.operations
const operations_view = state => state.operations_view
const operation_devices = state => state.operation_devices
const operation_devices_view = state => state.operation_devices_view
const operation_status = state => state.operation_status

export default {
  device_states,
  device_state,
  device_list_view,
  device_revisions,
  device_revisions_view,
  profile_revisions,
  profile_revisions_view,
  operations,
  operations_view,
  operation_devices,
  operation_devices_view,
  operation_status
}



// WEBPACK FOOTER //
// ./src/modules/endDeviceStates/store/getters.js